/**
 * Created by Ning Jiang on 9/3/2018.
 */

require("pixi-particles");

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {IceIceYetiGameConfig} from "../IceIceYetiGameConfig";

export class SnowStormParticles extends BaseView {

    private _backgroundConfig0:any = {
        "alpha" : {
            "start" : 0.7,
            "end" : 1
        },
        "scale" : {
            "start" : 0.2,
            "end" : 0.4,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 190,
            "end" : 250,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 320,
            "y" : 290
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 1000
        },
        "lifetime" : {
            "min" : 4,
            "max" : 8
        },
        "blendMode" : "normal",
        "frequency" : 0.05,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : GameConfig.instance.GAME_WIDTH,
            "h" : 1
        }
    };

    private _backgroundConfig1:any = {
        "alpha" : {
            "start" : 0.7,
            "end" : 1
        },
        "scale" : {
            "start" : 0.2,
            "end" : 0.4,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 90,
            "end" : 150,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 10,
            "y" : 190
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 1000
        },
        "lifetime" : {
            "min" : 4,
            "max" : 8
        },
        "blendMode" : "normal",
        "frequency" : 0.08,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : GameConfig.instance.GAME_WIDTH,
            "h" : 1
        }
    };

    private _foregroundConfig:any = {
        "alpha" : {
            "start" : 0.6,
            "end" : 0.9
        },
        "scale" : {
            "start" : 0.4,
            "end" : 0.6,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 200,
            "end" : 280,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 290,
            "y" : 320
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 100
        },
        "lifetime" : {
            "min" : 3,
            "max" : 7
        },
        "blendMode" : "normal",
        "frequency" : 0.01,
        "emitterLifetime" : -1,
        "maxParticles" : 150,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : GameConfig.instance.GAME_WIDTH,
            "h" : 1
        }
    };

    private _backgroundEmitters:Emitter[];
    private _foregroundEmitter:Emitter;
    private _currentMode:string;
    private _isPlaying:boolean;

    private _backgroundLayer:ScalableLayer;
    private _foregroundLayer:ScalableLayer;

    // private _textRect:PIXI.Graphics;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._backgroundEmitters = [];
        this._backgroundLayer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.BACKGROUND.name);
        this._foregroundLayer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.FOREGROUND.name);

        this._backgroundEmitters.push(this.createEmitter(this._backgroundLayer, [
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("snow1")
            },
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("snow2")
            },
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("snow3")
            }
        ], this._backgroundConfig0, true));
        this._backgroundEmitters.push(this.createEmitter(this._backgroundLayer, [
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("snow1")
            },
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("snow2")
            },
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("snow3")
            }
        ], this._backgroundConfig1, true));
        //this._backgroundEmitters.push(this.createEmitter(this._backgroundLayer, GameResources.getTextures("snow0"), this._backgroundConfig0, false));
        this._foregroundEmitter = this.createEmitter(this._foregroundLayer, GameResources.getTextures("snow0"), this._foregroundConfig, false);
    }

    private createEmitter(container:PIXI.Container, particleImages:any[], config:any, isAnimated:boolean):Emitter {
        const emitter:Emitter = new Emitter(container, particleImages, config);
        if(isAnimated) {
            emitter.particleConstructor = AnimatedParticle;
        }

        ParticlesManager.addEmitter(emitter, false);
        return emitter;
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event:GameEvent) => this.onChangeGameMode(event.params[0]));
    }

    private onChangeGameMode(data:IGameModeChangedData):void {
        if(data.newMode === this._currentMode) {
            return;
        }

        this._currentMode = data.newMode;
        this.changeStorm(this._currentMode === GameMode.RESPIN);
    }

    private changeStorm(play:boolean):void {
        if(play === this._isPlaying) {
            return;
        }

        this._isPlaying = play;
        this._backgroundEmitters.forEach((emitter:Emitter) => {
            emitter.emit = play;
        });
        this._foregroundEmitter.emit = play;

        if(play && this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
    }

    protected onResize(resizeData:IResizeData):void {
        this._resizeData = resizeData;

        if(!this._isPlaying) {
            this._isResizeDirty = true;
            return;
        }

        this._isResizeDirty = false;
        // The background and foreground has the same scale options.
        const screenRect:PIXI.Rectangle = new PIXI.Rectangle(
            -this._backgroundLayer.x / this._backgroundLayer.scale.x,
            -this._backgroundLayer.y / this._backgroundLayer.scale.y - 10,
            resizeData.width / this._backgroundLayer.scale.x,
            1);
        this._backgroundEmitters.forEach((emitter:Emitter) => {
            emitter.spawnRect = screenRect;
        });
        this._foregroundEmitter.spawnRect = screenRect;
        // if(!this._textRect) {
        //     this._textRect = new PIXI.Graphics();
        // }
        // this._textRect.clear();
        // this._textRect.beginFill(0xff0000);
        // this._textRect.drawRect(screenRect.x + 10, screenRect.y + 20, screenRect.width - 20, 100);
        // this._textRect.endFill();
        // this._backgroundLayer.addChild(this._textRect);
    }
}